import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CONFERENCE_STATUSES } from '@config/statuses-constants';
import { MIN_CONFERENCE_DURATION } from '@config/modelsConfig';
import { Panel } from '@layout';
import { Button } from '@atoms';
import { PageTemplate, ConferenceCallView } from '@templates';
import messages from './messages';

const ButtonsWrapper = styled.div`
  display: flex;

  & > button:not(:last-child) {
    margin-right: 25px;
  }
`;

export default class ConferenceViewPage extends PureComponent {
  static propTypes = {
    isSubmitting: PropTypes.bool,
    setField: PropTypes.func.isRequired,
    getConferenceById: PropTypes.func.isRequired,
    updateConference: PropTypes.func.isRequired,
    requestHumanTranscript: PropTypes.func.isRequired,
    conferenceData: PropTypes.object.isRequired,
    resetConference: PropTypes.func.isRequired,
    computedMatch: PropTypes.object.isRequired,
    isRequestingHumanTranscript: PropTypes.bool,
  };

  static defaultProps = {
    isSubmitting: false,
  };

  componentDidMount() {
    const conferenceId = this.props.computedMatch.params.id;
    this.props.getConferenceById(conferenceId);
  }

  componentWillUnmount() {
    this.props.resetConference();
    const conferenceId = this.props.computedMatch.params.id;
    this.props.getConferenceById(conferenceId);
  }

  updateConference = () => !this.props.isSubmitting && this.props.updateConference(false);

  requestHumanTranscript = () =>
    !this.props.isRequestingHumanTranscript && this.props.requestHumanTranscript();

  render() {
    const {
      conferenceData: { recordings, isRequestingHumanTranscript, edited, status },
    } = this.props;
    const shouldShowRequestTranscriptButton =
      recordings &&
      recordings.some(
        ({ duration, isSentToRev }) =>
          duration >= MIN_CONFERENCE_DURATION && !isSentToRev,
      );
    const isConferenceDeleted = status === CONFERENCE_STATUSES.DELETED;
    return (
      <PageTemplate title={<FormattedMessage {...messages.title} />}>
        <Panel>
          <ConferenceCallView />
          <ButtonsWrapper>
            {!isConferenceDeleted && (
              <Button
                onClick={this.updateConference}
                loading={this.props.isSubmitting}
                primary
              >
                <FormattedMessage {...messages.save} />
              </Button>
            )}
            {/* {!isAITranscriptNeeded && (
              <Button onClick={() => {}} loading={this.props.isSubmitting}>
                <FormattedMessage {...messages.requestAITranscript} />
              </Button>
            )} */}
            {shouldShowRequestTranscriptButton && (
              <Button
                disabled={edited}
                onClick={this.requestHumanTranscript}
                loading={isRequestingHumanTranscript}
              >
                <FormattedMessage {...messages.requestHumanTranscript} />
              </Button>
            )}
          </ButtonsWrapper>
        </Panel>
      </PageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/ConferenceViewPage/ConferenceViewPage.js